export default __webpack_public_path__ + "static/media/Assailing Pulls.66c200cb.png";